export const ru = {
    'approve-package': 'Подтвердить',
    'reject-package': 'Отклонить',
    'to-approve': 'Отправить на подтверждение',
    'to-edit': 'Редактировать'
};
